import GridwallRequestList from 'modules/gridwall-requests/components/GridwallRequestList/GridwallRequestList';
import useGridwallRequestListData from 'modules/gridwall-requests/hooks/useGridwallListData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';

const GridwallRequestPage = () => {
    const { gridwallRequests, isLoading } = useGridwallRequestListData();

    return (
        <PageTemplate>
            <PageHeading className="flex justify-between items-center">
                <div className="flex items-center gap-x-3">All GridWall Requests</div>
            </PageHeading>

            <div>
                <GridwallRequestList isLoading={isLoading} gridwallRequests={gridwallRequests} />
            </div>
        </PageTemplate>
    );
};

export default GridwallRequestPage;
